<template>
  <div class="privacy-consent" :class="{ 'privacy-consent--invalid': showError }">
    <input :id="inputId" v-model="checked" type="checkbox" class="privacy-consent-input" :required="required" />
    <label class="privacy-consent-label" :for="inputId">
      Я принимаю
      <router-link to="/privacy" target="_blank" class="privacy-consent-link">Политику обработки персональных данных</router-link>
      и
      <router-link to="/offer" target="_blank" class="privacy-consent-link">условия публичной оферты</router-link>,
      даю согласие на обработку моих персональных данных.
    </label>
    <p v-if="showError" class="privacy-consent-error" role="alert">Необходимо принять условия обработки персональных данных.</p>
  </div>
</template>
<script setup>
import { computed } from 'vue'
const props = defineProps({ modelValue: Boolean, required: { type: Boolean, default: true }, showError: Boolean, inputId: { type: String, default: 'privacy-consent' } })
const emit = defineEmits(['update:modelValue'])
const checked = computed({ get: () => props.modelValue, set: (v) => emit('update:modelValue', v) })
</script>
<style scoped>
.privacy-consent { display:flex; flex-wrap:wrap; gap:.65rem; align-items:flex-start; }
.privacy-consent-input { width:1rem; height:1rem; margin-top:.15rem; accent-color:#0071e3; }
.privacy-consent-label { flex:1; margin:0; font-size:.8rem; line-height:1.5; color:#6e6e73; }
.privacy-consent-link { color:#0071e3; text-decoration:none; }
.privacy-consent-error { width:100%; margin:0; font-size:.75rem; color:#ff3b30; }
.privacy-consent--invalid .privacy-consent-input { outline:2px solid #ff3b30; }
</style>
